import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import {
  ITheaterScreenNode,
  ITheaterScreenRewardDistribution,
} from '~/types/my-theater';
import ScreenNode from './ScreenNode.vue';
import PromotionScreenNode from './PromotionScreenNode.vue';
import HostingMomentsBanner from './HostingMomentsBanner.vue';
import { useStore } from '~/store/composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenNodes',
  props: {
    screenNodes: null
  },
  setup(__props: any) {

const props = __props as {
  screenNodes?: ITheaterScreenNode[];
};

const { state } = useStore();



const hasPurchasedNodes = computed(
  () => props.screenNodes && props.screenNodes.length > 0,
);

const dailyRewardDistributions = computed(
  () => state.myTheater?.dailyRewardDistributions,
);

const totalRewardDistributions = computed(
  () => state.myTheater?.totalRewardDistributions,
);

function nodeDailyRewardDistribution(node: ITheaterScreenNode) {
  if (!dailyRewardDistributions.value) return undefined;

  const distribution = dailyRewardDistributions.value.find(
    (x) => x.filmLicenseId === node.filmLicenseId,
  );
  return distribution?.rewardCount ?? 0;
}

function nodeTotalRewardDistribution(node: ITheaterScreenNode) {
  if (!totalRewardDistributions.value) return undefined;

  const distribution = totalRewardDistributions.value.find(
    (x) => x.filmLicenseId === node.filmLicenseId,
  );
  return distribution?.rewardCount ?? 0;
}

return { __sfc: true,state, props, hasPurchasedNodes, dailyRewardDistributions, totalRewardDistributions, nodeDailyRewardDistribution, nodeTotalRewardDistribution, ScreenNode, PromotionScreenNode, HostingMomentsBanner }
}

})